<template>
  <div>{{ colName }}</div>
</template>

<script>
export default {
  computed: {
    store() {
      return this.config?.store
    },
    cols() {
      return this.config?.cols
    },
    key() {
      return this.config?.key
    },
    colName() {
      return this.cols[this.config?.key]?.text || '-'
    }
  },
  props: {
    config: Object
  },
  methods: {}
}
</script>
